// require('/js/swiper-bundle.min.js');
// require('/js/extendStorage.js');

function require(script) {
    $.ajax({
        url: script,
        dataType: "script",
        async: false, // <-- This is the key
        success: function() {
            // all good...
        },
        error: function() {
            throw new Error("Could not load script " + script);
        }
    });
}

$(function() {
    var swiper = new Swiper(".mySwiper", {
        // slidesPerView: 1,
        spaceBetween: 55,
        slidesPerView: "auto",
        // visibilityFullFit: true,
        // autoResize: false,
        // centeredSlides: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: false,
            hide: true
        }
    });

    var Window_ = $(window);

    Window_.on("resize", function() {
        setObjcompare(localStorage.get("dataKey"));
    });

    var chkWindow_ = 576;
    var DATAObj = {};
    var openBox = "close";

    if (localStorage.getItem("dataKey") === null) {
        localStorage.set("dataKey", {});
        localStorage.set("DATA_ALL", {});
        // localStorage.set('datagade',{});
    }

    if (localStorage.getItem("toolBoxcompare") === null) {
        localStorage.set("toolBoxcompare", false);
    }
    // localStorage.set('toolBoxcompare', openBox);
    $(".box-menu-footer").addClass("clear-animate");

    Boxcompare(localStorage.get("toolBoxcompare"));
    function Boxcompare(chk) {
        // localStorage.set('toolBoxcompare',chk); // เชคสถานะเปิดปิดปุ่ม popup compare
        if (chk == "open") {
            $(".box-menu-footer").removeClass("showbox");
            $(".box-menu-footer").addClass("open-mini");
            $(".box-menu-footer").addClass("open");
        } else {
            $(".box1").removeClass("open");
            $(".box-menu-footer").removeClass("clear-animate");
            $(".box-menu-footer").removeClass("open");
        }
    }

    setValueCompare = {};
    setValueCompare = localStorage.get("dataKey");
    setObjcompare(setValueCompare);
    getCheckBox();
    // showbox
    $(".box-menu-footer").addClass("showbox");

    $("select")
        .selectric()
        .on("change", function(e) {
            let submodelType = $(this).val();
            let chkBox = $(this)
                .parent()
                .parent()
                .parent()
                .parent()
                .find($('.check-box input[type="checkbox"]'));
            if (chkBox.prop("checked") == true) {
                setValueCompare[chkBox.val()] = [
                    { idmodel: chkBox.data("idmodel"), logo: chkBox.data("logo"), name: chkBox.val(), submodelType: submodelType }
                ];
                localStorage.set("dataKey", setValueCompare);
            }
        });

    $(".input-checkbox").on("click", function(e) {
        // ปุ่มกด ckeckbox ให้เลือก compare
        // $('.modelkey_'+$(this).data('idmodel')).addClass('active');
        var objGradepage = $(".modelkey_" + $(this).data("idmodel"));

        var max_length = 2; // chk mobie add model
        if ($(window).width() > 768) {
            max_length = 3; // chk desktop add model
        }
        var check_ = $(this).prop("checked");

        openBox = "open";
        Boxcompare(openBox);
        // $('.box-menu-footer').addClass('open');
        if (check_ == true && Object.entries(setValueCompare).length < max_length) {
            $(".modelkey_" + $(this).data("idmodel"))
                .parent()
                .parent()
                .addClass("active");
            $(".modelkey_" + $(this).data("idmodel")).prop("checked", true);
            $(this)
                .parent()
                .parent()
                .addClass("active");
            // let submodelType = $(this).parent().parent().parent().find($('.list-compare .select-type')).val();
            let submodelType = $(this)
                .parent()
                .parent()
                .parent()
                .find($(".list-compare .select-type"))
                .val();
            if (typeof submodelType == "undefined" && submodelType == null) {
                submodelType = $(this).data("submodeltype");
            }
            setValueCompare[$(this).val()] = [
                { idmodel: $(this).data("idmodel"), logo: $(this).data("logo"), name: $(this).val(), submodelType: submodelType }
            ];
            localStorage.set("dataKey", setValueCompare);
            // $('.box-menu-footer').addClass('open');
            // }
            if (Object.entries(setValueCompare).length >= 3) {
                $(".box1").removeClass("open");
            }
        } else if (check_ == false) {
            objGradepage
                .parent()
                .parent()
                .removeClass("active"); // เชคหน้า gade.blade
            objGradepage.prop("checked", false); // เชคหน้า gade.blade

            $(this)
                .parent()
                .parent()
                .removeClass("active");
            delete setValueCompare[$(this).val()];
            localStorage.set("dataKey", setValueCompare);
        } else if (check_ == true) {
            objGradepage.prop("checked", false); // เชคหน้า gade.blade

            $(this).prop("checked", false);
        }
        setObjcompare(setValueCompare);
    });

    // clear banner and add show banner all compare
    function setObjcompare(obj) {
        var $str_ = "";
        var $str_Btn = "";
        var num_ = 1;
        $(".listbox .row").html("");
        // var getHostname2 = '{!! asset("images/close-btn.svg") !!}';
        $.each(obj, function(key, value) {
            $str_ += '<div class="col-6 col-lg-3 box-colum"><div class="box-item listbox' + num_ + '">';
            // $str_ +='<img class="icon-logo-item" src="'+value[0]['logo']+'" alt="Logo banner compare">'
            $str_ += value[0]["name"];
            $str_ +=
                '<img class="gtm-icon-close-banner icon-clode-banner"  data-idmodel="' +
                value[0]["idmodel"] +
                '"  data-model="' +
                value[0]["name"] +
                '" src="' +
                getpath_Asset +
                'images/close-btn.svg" alt="banner compare">';
            $str_ += "</div></div>";

            num_++;

            // Set compare checked
            $(".compare-checkbox-" + value[0]["idmodel"]).attr("data-comparechecked", "Unchecked");
        });
        $(".listbox .row").append($str_);
        $(".text-compare-num").html(str_trans + " (" + Object.entries(obj).length + "/" + "2)");
        $(".icon-clode-banner").on("click", function(e) {
            let chkboxName = $(".modelkey_" + $(this).data("idmodel"));
            chkboxName.prop("checked", false);
            chkboxName
                .parent()
                .parent()
                .removeClass("active");
            delete setValueCompare[$(this).data("model")];
            localStorage.set("dataKey", setValueCompare);
            setObjcompare(localStorage.get("dataKey"));
        });

        var max_length = 2; // chk mobie add model
        if (Window_.width() > 768) {
            max_length = 3; // chk desktop add model
            $(".listbox" + (num_ - 1)).show();
        }

        if (Object.entries(obj).length < max_length) {
            $str_ = "";
            $str_ += '<div class="col-6 col-lg-3"><div class="box-item btn-add-compare">';
            $str_ +=
                '<div class="gtm-add-compare add-compare"><img class="icon-add-item" src="' +
                getpath_Asset +
                'images/close-btn.svg" alt="banner compare">';
            $str_ += '<p class="text-add">' + lang_trans_addcarmodel + "</p></div>";
            $str_ += "</div></div>";
            $(".listbox .row").append($str_);
            $(".btn-add-compare").on("click", function(e) {
                e.preventDefault();
                // if($(window).width()<=chkWindow_){
                // let wd_ = $(window).height();
                // let box2_ = $('.box2').height();
                // let h_ = (wd_ - box2_)-90;
                // $('.box1').height(h_);
                // }
                $(".box-grad-bg-mb").addClass("open");
                $(".box1").addClass("open");
                $(".box1").one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function() {});
            });
        }
        var listNum = (3 - (Object.entries(obj).length + 1)) * 3;
        var chkoffset_ = "offset-lg-" + listNum;
        $str_Btn += '<div class="col-6 col-lg-3 d-none d-lg-block ' + chkoffset_ + '">';
        $str_Btn += '<div class="box-btn">';
        $str_Btn +=
            '<button id="submit-compare-btn" class="gtm-submit-compare btn btn-primary btn-arrow btn-arrow-right aos-init aos-animate s-height">';
        $str_Btn += "<span>" + lang_trans_txt_compare + "</span>";
        $str_Btn += "</button>";
        $str_Btn += '<div class="gtm-clear-compare clear-btn">' + lang_trans_txt_clear + "</div>";
        $str_Btn += "</div></div>";
        $(".listbox .row").append($str_Btn);
        $(".clear-btn").css("cursor", "pointer");
        $(".clear-btn").on("click", function(e) {
            e.preventDefault();

            $(".listbox .row").html("");
            // DATAObj = {}
            setValueCompare = {};
            // localStorage.clear();
            localStorage.set("dataKey", setValueCompare);
            setObjcompare(setValueCompare);
            clearCheckBox();
        });

        $("#submit-compare-btn").on("click", function(e) {
            // Set relay
        });
    }

    function getCheckBox() {
        var obj_ = $(".grad-page");

        $(".input-checkbox").each(function() {
            let submodelType = $(this)
                .parent()
                .parent()
                .parent()
                .find($(".list-compare .select-type"))
                .val();
            DATAObj[$(this).val()] = [
                { idmodel: $(this).data("idmodel"), logo: $(this).data("logo"), name: $(this).val(), submodelType: submodelType }
            ];
            if ($(this).prop("checked") == false && typeof localStorage.get("dataKey")[$(this).val()] !== "undefined") {
                $(this)
                    .parent()
                    .parent()
                    .addClass("active");
                $(this).prop("checked", true);
                $(this)
                    .parent()
                    .parent()
                    .parent()
                    .find($(".list-compare .select-type"))
                    .val(localStorage.get("dataKey")[$(this).val()][0].submodelType)
                    .change()
                    .selectric("refresh");
            }
        });
        if (obj_.length == 0) {
            localStorage.set("DATA_ALL", DATAObj);
        }
    }
    function clearCheckBox() {
        $(".input-checkbox").each(function() {
            $(this)
                .parent()
                .parent()
                .removeClass("active");
            $(this).prop("checked", false);
        });
    }

    // ----------------- script filter ------------------//
    $("#price10").on("click", function(e) {
        if ($(this).prop("checked") == true) {
            $('.price-range input[class="form-check-input"]').each(function() {
                $(this).prop("checked", true);
            });
        } else {
            $('.price-range input[class="form-check-input"]').each(function() {
                $(this).prop("checked", false);
            });
        }
    });

    $(".price-range .form-check-input").on("click", function(e) {
        var chkObj10 = $("#price10");
        if (chkObj10.prop("checked") == true) {
            var i = 1;
            var chkObj;
            $('.price-range input[class="form-check-input"]').each(function() {
                chkObj = $(this).prop("checked");
                if (chkObj == false) {
                    chkObj10.prop("checked", false);
                    return false;
                }
                i++;
            });
        }
    });

    // let hh_ =  ($('.box-slickybar').height());
    // $('.box-menu-footer').css({'bottom': hh_});

    // click close banner clear
    $(".icon-close").on("click touchstart", function(e) {
        e.preventDefault();
        // $('.box1').removeClass('open');
        // $('.box-menu-footer').removeClass('open');
        // let hh_ =  (240-$('.box-slickybar').height())-34;
        // $('.box-menu-footer').css({'bottom': -hh_});
        if (openBox == "open") {
            // hh_ =  (240-$('.box-slickybar').height())-34;
            // $('.box-menu-footer').css({'bottom': -hh_});
            openBox = "close";
        } else {
            // hh_ =  $('.box-slickybar').height();
            // $('.box-menu-footer').css({'bottom': hh_});
            openBox = "open";
        }

        Boxcompare(openBox);
    });
    $(".icon-close-minibox").on("click touchstart", function(e) {
        e.preventDefault();
        // hh_ =  ($('.box-slickybar').height());
        // $('.box-menu-footer').css({'bottom': hh_});
        // $('.box1').removeClass('open');
        // $('.box-menu-footer').removeClass('clear-animate');
        // $('.box-menu-footer').removeClass('open');
        // $('.box-menu-footer').removeClass('showbox');
        $(".box-menu-footer").removeClass("open-mini");
        $(".box-menu-footer").addClass("showbox");
    });

    // add logo compare
    $(".icon-logo").on("click", function(e) {
        // e.preventDefault();
        setValueCompare = localStorage.get("dataKey");
        let idmodel = $(this).data("idmodel");
        let logo = $(this).data("logo");
        let name = $(this).data("model");
        let submodelType = $(this).data("submodeltype")[0]["id"];
        let chkboxName = $(".modelkey_" + idmodel);
        chkboxName.prop("checked", true);
        chkboxName
            .parent()
            .parent()
            .addClass("active");
        setValueCompare[$(this).data("model")] = [{ idmodel: idmodel, logo: logo, name: name, submodelType: submodelType }];
        localStorage.set("dataKey", setValueCompare);
        setObjcompare(localStorage.get("dataKey"));
        $(".box1").removeClass("open");
        $(".box-grad-bg-mb").removeClass("open");
    });

    //click menutool right
    $(".btn-box-compare").on("click", function(e) {
        openBox = "open";
        Boxcompare(openBox);
    });

    // btn click compare
    $("#compare-result").on("submit", function(e) {
        let model_id = [];
        let grade_id = [];
        let model_name = [];
        $.each(localStorage.get("dataKey"), function(key, value) {
            model_id.push(value[0]["idmodel"]);
            grade_id.push(value[0]["submodelType"]);
            model_name.push(value[0]["name"]);
        });

        $('input[name="model_id"]').val(model_id);
        $('input[name="grade_id"]').val(grade_id);
        if (model_id.length < 2) {
            alert("กรุณาเลือกเปรียบเทียบรถยนต์ 2 รุ่น ขึ้นไป");
            e.preventDefault();
        } else {
            localStorage.clear();
            /// CDP Tracking ///
            let dateNow = moment().format("YYYY-MM-DD HH:mm:ss");
            analytics.track("Car Compare", {
                car_model_1: model_name[0] || null,
                ...findCarCateByCompare(model_name[0] || null, "1"),
                car_model_2: model_name[1] || null,
                ...findCarCateByCompare(model_name[1] || null, "2"),
                car_model_3: model_name[2] || null,
                ...findCarCateByCompare(model_name[2] || null, "3"),
                created_date: dateNow
            });
            // Gtag Tracking //
            gtag("event", "page all model", {
                section_name: "compare model",
                car_model_1: model_name[0] || null,
                car_model_2: model_name[1] || null,
                car_model_3: model_name[2] || null,
                action_type: "click on page",
                created_date: dateNow
            });
        }
    });

    $(".tag-text").on("click", function() {
        if ($(this).data("clear") != "clear") {
            $(this).remove();
            // $(".box-tag").html('');
        }
        let strUrl = "";
        if ($(this).data("tagvalue") != "models") {
            $(".tag-text", ".box-tag").each(function(index, obj) {
                if ($(this).data("tagvalue") != "models") {
                    strUrl = strUrl + "tags[]=" + $(this).data("tagvalue") + "&";
                }
            });
        } else {
            strUrl = "models";
        }
        window.location.href = "models?" + strUrl;
    });

    var _filterBox = $(".box-overflow");
    $(".clear-btn-filter").on("click", function() {
        $(".form-check-input", _filterBox)
            .prop("checked", false)
            .removeAttr("checked");
    });
});



// WEBPACK FOOTER //
// ./resources/js/model-compare-popup.js